import { useState } from "react";

export default function SubscribeCta() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) setDone(true);
  };

  return (
    <section id="subscribe" className="mx-auto max-w-[1400px] scroll-mt-24 px-4 pb-12 md:px-6">
      <div className="rounded-lg border border-foreground-200/60 bg-background-100/70 px-6 py-8 md:px-10 md:py-10">
        <div className="grid items-center gap-6 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-black text-foreground-950">开启塌房 &amp; 深扒推送提醒</h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              输入邮箱订阅「网曝网」，热点事件、人物档案与黑料合集更新将第一时间推送到你的收件箱。
            </p>
          </div>
          <div>
            {done ? (
              <div className="flex items-center gap-3 rounded-md border border-primary-300 bg-primary-50 px-4 py-3 text-sm text-primary-800">
                <i className="ri-checkbox-circle-fill text-xl text-primary-600" />
                订阅成功，最新深扒会及时送达你的邮箱。
              </div>
            ) : (
              <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row">
                <label className="sr-only" htmlFor="sub-email">邮箱地址</label>
                <input
                  id="sub-email"
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  className="h-12 flex-1 rounded-md border border-foreground-300/60 bg-background-50 px-4 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-500"
                />
                <button
                  type="submit"
                  className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-foreground-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-notification-3-line" /> 订阅提醒
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}